export class UsuarioModel {
    idUsuario?: number;
    idPersona?: number;
    idPerfil?: number;
    descripcionPerfil?: string;
    usuario: string;
    usuarioDa: string;
    claveOrigen: string;
    email: string;
    imagen: string;
    themeDark: boolean;
    themeColor: string;
    typeMenu: string;
    flgActivo: boolean;
    idUnidad?: number;
    descripcionUnidad?: string;
    

    // Auditoria
    regUsuario?: number;
    regEstacion?: string;

    constructor(){
        this.idUsuario = 0;
        this.idPersona = 0;
        this.idPerfil = 0;
        this.descripcionPerfil = '';
        this.usuario = '';
        this.usuarioDa = '';
        this.claveOrigen = '';
        this.email = '';
        this.imagen = '';
        this.themeDark = false;
        this.themeColor = '';
        this.typeMenu = '';
        this.flgActivo = true;
        this.regUsuario = 0;
        this.regEstacion = '';
        this.idUnidad =0;
        this.descripcionUnidad = '';
        
    }
}